// extracted by mini-css-extract-plugin
module.exports = {"figure":"pictureGalleryImage_figure__25Fya"};